import { useStyles } from '@webapps/styles';
import Employer from './Employer';
import Student from './Student';
import Master from './Master';
import Contract from './Contract';
import Training from './Training';
import AddEmployer from './AddEmployer';

const ConventionAndCerfa = ({ hidden = false, opcoRecord, refetch, reportInvalid, invalidCounts, totalInvalid, openAddEmployerAccordion, setOpenAddEmployerAccordion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  return (
    <div className={cx(global.fcjs, classes.gap, hidden && classes.hide)}>
      {opcoRecord?.businessEmployer ? (
        <>
          <Employer opcoRecord={opcoRecord} refetch={refetch} sectionKey="employer" reportInvalid={reportInvalid} />
          <Master opcoRecord={opcoRecord} refetch={refetch} sectionKey="master" reportInvalid={reportInvalid} />
          <Contract opcoRecord={opcoRecord} refetch={refetch} sectionKey="contract" reportInvalid={reportInvalid} />
        </>
      ) :
        <AddEmployer opcoRecord={opcoRecord} refetch={refetch} sectionKey="add-employer" reportInvalid={reportInvalid} openAddEmployerAccordion={openAddEmployerAccordion} setOpenAddEmployerAccordion={setOpenAddEmployerAccordion} />
      }
      <Student opcoRecord={opcoRecord} refetch={refetch} sectionKey="student" reportInvalid={reportInvalid} />
      <Training opcoRecord={opcoRecord} refetch={refetch} sectionKey="training" reportInvalid={reportInvalid} />
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  gap: {
    gap: 20,
  },
  hide: {
    display: 'none',
  },
});

export default ConventionAndCerfa;